<script>
  import { router } from '@inertiajs/svelte'
  import ApplicationLayout from '../../components/ApplicationLayout/index.svelte'
  import PropertyForm from '../../components/PropertyForm/index.svelte'
  
  let { property, property_types, spaces = [], addresses = [] } = $props()
  let showDeleteConfirm = $state(false)
  
  function handleDelete() {
    if (confirm('Are you sure you want to delete this property? This action cannot be undone.')) {
      router.delete(`/properties/${property.id}`)
    }
  }
</script>

<svelte:head>
  <title>Edit Property | Maset</title>
</svelte:head>

<ApplicationLayout>
  <div class="container mx-auto p-4">
    <div class="max-w-2xl mx-auto">
      <div class="flex justify-between items-center mb-6">
        <h1 class="text-2xl font-bold">Edit Property</h1>
        <button 
          onclick={() => showDeleteConfirm = true}
          class="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
        >
          Delete
        </button>
      </div>
      
      <PropertyForm
        property={property}
        property_types={property_types}
        spaces={spaces}
        addresses={addresses}
        submitUrl={`/properties/${property.id}`}
        submitMethod="put"
      >
        {#snippet actions()}
          <div>
            <a
              href={`/properties/${property.id}`}
              class="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded mr-2"
            >
              Cancel
            </a>

            <button
              type="submit"
              class="bg-brand-700 hover:bg-brand-800 text-white font-bold py-2 px-4 rounded"
            >
              Update Property
            </button>
          </div>
        {/snippet}
      </PropertyForm>
      
      {#if showDeleteConfirm}
        <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div class="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <h2 class="text-xl font-bold mb-4">Confirm Deletion</h2>
            <p class="mb-6">Are you sure you want to delete this property? This action cannot be undone and will remove all related spaces, containers, and items.</p>
            <div class="flex justify-end">
              <button 
                onclick={() => showDeleteConfirm = false}
                class="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded mr-2"
              >
                Cancel
              </button>
              <button 
                onclick={handleDelete}
                class="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
              >
                Delete Property
              </button>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
</ApplicationLayout>